// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdateMachineDowntimeEndMutation(
    $input: UpdateMachineDowntimeEndInput!
  ) {
    updateMachineDowntimeEnd(input: $input) {
      machineEdge {
        cursor
        node {
          id
          name
          currentDowntime {
            id
            startNotes
            endNotes
            startAt
            endAt
            startUser {
              id
              firstName
              lastName
              avatar
            }
            endUser {
              id
              firstName
              lastName
              avatar
            }
            category {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
